import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import api from '../api/axios';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentBusiness, setCurrentBusiness] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    const savedBusiness = localStorage.getItem('currentBusiness');
    
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
      if (savedBusiness && savedBusiness !== 'null') {
        setCurrentBusiness(JSON.parse(savedBusiness));
      }
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (user && !currentBusiness) {
      const savedBusiness = localStorage.getItem('currentBusiness');
      if (savedBusiness && savedBusiness !== 'null') {
        setCurrentBusiness(JSON.parse(savedBusiness));
      } else {
        api.get('/businesses').then(res => {
          if (res.data && res.data.length > 0) {
            const biz = res.data[0];
            localStorage.setItem('currentBusiness', JSON.stringify(biz));
            setCurrentBusiness(biz);
          }
        }).catch(() => {});
      }
    }
  }, [user, currentBusiness]);

  const login = async (phone, password) => {
    const response = await api.post('/auth/login', { phone, password });
    const userData = response.data;
    localStorage.setItem('token', userData.token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
    try {
      const bizRes = await api.get('/businesses');
      if (bizRes.data && bizRes.data.length > 0) {
        localStorage.setItem('currentBusiness', JSON.stringify(bizRes.data[0]));
        setCurrentBusiness(bizRes.data[0]);
      }
    } catch (e) {}
    return userData;
  };

  const register = async (data) => {
    const response = await api.post('/auth/register', data);
    const userData = response.data;
    localStorage.setItem('token', userData.token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
    return userData;
  };

  const logout = () => {
    localStorage.clear();
    setUser(null);
    setCurrentBusiness(null);
  };

  const switchBusiness = (business) => {
    localStorage.setItem('currentBusiness', JSON.stringify(business));
    setCurrentBusiness(business);
    setRefreshKey(prev => prev + 1); // Trigger re-render of all components
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, loading, currentBusiness, switchBusiness, refreshKey }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
